
import { Component, mixins, Watch, Ref, Emit, Prop, namespace } from 'nuxt-property-decorator';
import SimpleBar from 'simplebar';
import EventSideNavPanel from './side-nav-panel/EventSideNavPanel.vue';
import OrganizerSideNavPanel from './side-nav-panel/OrganizerSideNavPanel.vue';
import { RouteContextMixin, OrganizationMixin } from '~/mixins';
import { GlobalDropdownEvents, Role } from 'fourwaves-shared';

const SettingsModule = namespace('settings');

@Component({
  components: {
    EventSideNavPanel,
    OrganizerSideNavPanel,
  },
})
export default class SideNav extends mixins(RouteContextMixin, OrganizationMixin) {
  @SettingsModule.Getter hasOrganizationRole!: (organizationId: string, role: Role) => boolean;

  @Prop(Boolean) isFloating!: boolean;
  @Ref() readonly sideNavScroll?: HTMLElement;

  @Emit() onToggleMode() {}

  isHover = false;
  simplebarInstance: SimpleBar | null = null;

  get isAdministrator(): boolean {
    if (!this.organization) return false;

    return this.hasOrganizationRole(this.organization.id, Role.Administrator);
  }

  get hideSideNav(): boolean {
    const forceSideNavForTransition = !!this.$route.name && this.$route.name.startsWith('organizations');

    if (!this.isInOrganizerDashboard && !this.isInEventDashboard && !forceSideNavForTransition) return true;
    return this.isInOrganizerDashboard && !this.isAdministrator;
  }

  get isCollapsed(): boolean {
    return !this.isHover && this.isFloating;
  }

  get classNames(): Record<string, boolean> {
    return {
      '-dark': this.isInOrganizerDashboard,
      '-hover': this.isHover && this.isFloating,
      '-floating': this.isFloating,
    };
  }

  @Watch('$route')
  onRouteChanged() {
    this.isHover = false;
  }

  @Watch('isHover')
  onIsHoverChanged(isHover: boolean) {
    if (this.isFloating && isHover) this.$nuxt.$emit(GlobalDropdownEvents.Close);
  }

  public toggleMode() {
    if (!this.isFloating) this.isHover = false;
    this.onToggleMode();
  }

  async mounted() {
    await this.$nextTick();
    if (!this.sideNavScroll) return;
    this.simplebarInstance = new SimpleBar(this.sideNavScroll);
    await this.$nextTick();
    this.sideNavScroll?.querySelector('[tabindex="0"]')?.removeAttribute('tabindex');
  }
}
